<template>
  <el-container v-title data-title="订单记录" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>财务管理</el-breadcrumb-item>
                <el-breadcrumb-item>月度总额统计</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="yearMonth" label="月份" width="110"></el-table-column>
          <el-table-column prop="yearFeeAmount" label="年费总额" width="90"></el-table-column>
          <el-table-column prop="regainCardAmount" label="补卡总额" width="90"></el-table-column>
          <el-table-column prop="yearFeeRefundAmount" label="年费退款" width="90"></el-table-column>
          <el-table-column prop="regainCardRefundAmount" label="补卡退款" width="90"></el-table-column>
          <el-table-column prop="total" label="总计" width="90"></el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getOrderStatsList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    getOrderStatsList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/order/statYearMonthToAmountAndRefund').then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.tableData = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/StatsForOrderAmount.vue